import { render, staticRenderFns } from "./AutomatedReport.vue?vue&type=template&id=510a1fb6"
import script from "./AutomatedReport.vue?vue&type=script&lang=ts"
export * from "./AutomatedReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports